import type { TClpBanner } from '@/components/campaign/banner/types'

export const useDynamicClpBannerTitle = () => {
  const { t } = useI18n()

  const route = useRoute()
  const cheapestAvailableFlight = useState<number | null>(`cheapest-available-flight:${route.params.slug}`, () => null)

  const getTitleContent = (blok: TClpBanner) => {
    return computed(() => {
      if (!blok.showDynamicCheapestPriceInTitle || !cheapestAvailableFlight.value) {
        return blok.title
      }

      return `${blok.title} ${t('flightsFromPriceInEur', { price: cheapestAvailableFlight.value })}`
    })
  }

  return {
    getTitleContent
  }
}
